import React from "react"
import styled from "styled-components"
import getId from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import GetCommentTagCountQuery from "@irati/insights/apollo/query/comment/getTagCount"
import {overrideAuth} from "@irati/insights/utils/apollo"
import {RadioFilter} from "@irati/ui/src/FormItem"

import AnalysisCommentsConsumer from "../AnalysisCommentsConsumer"
import {BOOKMARK_TYPE, BOOKMARK_TYPE_TAG_VALUE} from "../../../utils/constants/comment"
import DropDownLabel from "../../../ui/Labels/DropdownLabel"

const Wrapper = styled.div`
  padding-right: 2px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const Title = styled.div`
  margin-right: 10px;
`

const BookmarkHeaderRenderer = (props) => {
  const idNamespace = getId("BookmarkHeaderRenderer", props)

  const placeholder = (
    <DropDownLabel>
      <FormattedMessage id="insights.comments.bookmarks.filterEmptyText" />
    </DropDownLabel>
  )
  return (
    <div>
      <AnalysisCommentsConsumer>
        {({tenantId: tenant, bookmark, filters, commentsFilters, updateFilter, schedule: cycle, isDemo, demoTenantAccessToken}) => {
          const {sentiment} = commentsFilters
          const queryParams = {tenant, cycle, tagType: BOOKMARK_TYPE, tagValue: BOOKMARK_TYPE_TAG_VALUE, filters: {...filters, sentiment}}

          return (
            <GetCommentTagCountQuery {...queryParams} useLoader={false} {...overrideAuth(demoTenantAccessToken, isDemo)}>
              {({tagCount: {results: bookmarks = []}}) => {
                const options = bookmarks.map(({value, count}) => {
                  const label = `${value} (${count})`
                  return {value, label}
                })
                return (
                  <Wrapper id={idNamespace}>
                    <Title>
                      <FormattedMessage id="insights.comments.bookmarks.headerText" />{" "}
                    </Title>
                    <RadioFilter
                      options={options}
                      value={bookmark}
                      placeholder={placeholder}
                      pullRight
                      onReset={() => updateFilter(null, BOOKMARK_TYPE)}
                      onChange={(value) => updateFilter(value, BOOKMARK_TYPE)} />
                  </Wrapper>
                )
              }}
            </GetCommentTagCountQuery>
          )
        }}
      </AnalysisCommentsConsumer>
    </div>
  )
}

export default BookmarkHeaderRenderer
